import { render, staticRenderFns } from "./MessageInformation.vue?vue&type=template&id=637710ab&scoped=true"
import script from "./MessageInformation.vue?vue&type=script&lang=js"
export * from "./MessageInformation.vue?vue&type=script&lang=js"
import style0 from "./MessageInformation.vue?vue&type=style&index=0&id=637710ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637710ab",
  null
  
)

export default component.exports